const getRequiredEnv = (name: keyof ImportMetaEnv): string => {
  const value = import.meta.env[name];

  if (!value) {
    throw new Error(`Missing required env variable: ${String(name)}`);
  }

  return value;
};

export const MF_NAME = getRequiredEnv('VITE_MF_NAME');
